import React, { useState, useEffect, useRef } from 'react';
import { usePopup } from './PopupContext';

const Frontpopup_form = () => {
  const { showPopup, setShowPopup } = usePopup();
  const [shouldRender, setShouldRender] = useState(showPopup);
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const courseOptions = [
    { value: 'AWS Cloud & DevOps', label: 'AWS Cloud & DevOps' },
    { value: 'Data Analytics', label: 'Data Analytics' },
    { value: 'Data Science', label: 'Data Science' },
    { value: 'Cyber Security', label: 'Cyber Security' },
    { value: 'Full Stack JAVA', label: 'Full Stack JAVA' },
    { value: 'Full Stack .NET', label: 'Full Stack .NET' },
    { value: 'Full Stack Python', label: 'Full Stack Python' },
    { value: 'MERN Stack', label: 'MERN Stack' },
    { value: 'Software Testing', label: 'Software Testing' },
    { value: 'Android Development', label: 'Android Development' },
    { value: 'Digital Marketing', label: 'Digital Marketing' },
    { value: 'Internship programs', label: 'Internship programs' },
  ];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    branch: '',
    course: [],
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (showPopup) {
      setShouldRender(true);
    } else {
      const timeout = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [showPopup]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required.';
    } else if (!/^[A-Za-z ]+$/.test(formData.name.trim())) {
      newErrors.name = 'Name can contain only letters and spaces.';
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Name must be at least 2 characters.';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      newErrors.email = 'Email is invalid.';
    }

    if (!formData.contact.trim()) {
      newErrors.contact = 'Contact is required.';
    } else if (!/^\d{10}$/.test(formData.contact)) {
      newErrors.contact = 'Contact must be 10 digits.';
    }

    if (!formData.course.length) {
      newErrors.course = 'Please select at least one course.';
    }

    if (!formData.branch) {
      newErrors.branch = 'Branch selection is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
  if (!validateForm()) return;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE}/enquiries`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...formData, course: formData.course.join(', ') }),
    });

    const result = await response.json();

    if (response.status === 409) {
      alert('An enquiry with this email or contact already exists.');
    } else if (response.ok) {
      alert('Enquiry submitted!');
      setFormData({ name: '', email: '', contact: '', branch: '', course: [] });
      setErrors({});
      setShowPopup(false);
    } else {
      alert(result.error || 'Failed to submit enquiry');
    }
  } catch (err) {
    console.error(err);
    alert('Error submitting enquiry');
  }
};


  if (!shouldRender) return null;

  return (
    <>
      <div
        className={`popup-overlay ${showPopup ? 'fade-in' : 'fade-out'}`}
        onClick={() => setShowPopup(false)}
      ></div>

      <div className={`frontpopup ${showPopup ? 'fade-in' : 'fade-out'}`} id="frontpopupshow">
        <button className="frontclose-button" onClick={() => setShowPopup(false)}>
          &times;
        </button>

        <h2 className="title1">Enquiry Form</h2>
        <hr />

        <form onSubmit={(e) => e.preventDefault()}>

          <select
            name="branch"
            className="form-control pb-3 mb-2"
            value={formData.branch}
            onChange={handleChange}
          >
            <option value="" disabled>
              Select Branch
            </option>
            <option value="Shivajinagar, Pune">Shivajinagar, Pune</option>
            <option value="Pimpri-Chinchwad, Pune">Pimpri-Chinchwad, Pune</option>
            <option value="Bengaluru/Bangalore">Bengaluru/Bangalore</option>
          </select>
          {errors.branch && <small className="text-danger">{errors.branch}</small>}

          <div className="mb-3" ref={dropdownRef}>
            <div className="dropdown">
              <button
                type="button"
                className="form-control text-start"
                onClick={() => setDropdownOpen((prev) => !prev)}
              >
                {formData.course.length > 0
                  ? formData.course.join(', ')
                  : 'Select Course(s)'}
              </button>

              {dropdownOpen && (
                <div
                  className="dropdown-menu show p-2 border w-100"
                  style={{ maxHeight: '200px', overflowY: 'auto' }}
                >
                  {courseOptions.map((option) => (
                    <div className="form-check" key={option.value}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={option.value}
                        value={option.value}
                        checked={formData.course.includes(option.value)}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setFormData((prev) => {
                            const newCourses = isChecked
                              ? [...prev.course, option.value]
                              : prev.course.filter((val) => val !== option.value);
                            return { ...prev, course: newCourses };
                          });
                        }}
                      />
                      <label className="form-check-label" htmlFor={option.value}>
                        {option.label}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {errors.course && <small className="text-danger">{errors.course}</small>}
          </div>

          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            className="form-control pb-3 mb-2"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <small className="text-danger">{errors.name}</small>}

          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            className="form-control pb-3 mb-2"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <small className="text-danger">{errors.email}</small>}

          <input
            type="number"
            name="contact"
            placeholder="Enter your contact"
            className="form-control pb-3 mb-2"
            value={formData.contact}
            onChange={handleChange}
          />
          {errors.contact && <small className="text-danger">{errors.contact}</small>}

          

          

          <div className="d-grid pb-3 mt-3">
            <button className="btn btn-primary" type="button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Frontpopup_form;
